export const LOGGING_ENABLED = ({
  'local': true,
  'local-itouat': true,
  'itodev': true,
  'itouat': true,
  'itosit': true,
  'prod': true,
})[process.env.WOW_API_ENV] || true;

// Minimum level to buffer a log entry (controls what gets captured per env)
export const MIN_LOG_LEVEL = ({
  'local': 1000,
  'local-itouat': 1000,
  'itodev': 1000,
  'itouat': 1000,
  'itosit': 1000,
  'prod': 4000,
})[process.env.WOW_API_ENV] || 1000;

// Minimum level to trigger an immediate flush (warn+ always sends right away)
export const IMMEDIATE_SEND_MIN_LEVEL = 4000;

export const LOGGING_SEND_INTERVAL = 60000;

export const LOGGING_INCLUDED_ACTIONS = [
  'WORK_ORDER_GET_STARTED',
  'WORK_ORDER_GET_FINISHED',
  'WORK_ORDER_GET_FAILED',

  'WORK_ORDER_GET_TECH_ROUTE_STARTED',
  'WORK_ORDER_GET_TECH_ROUTE_FINISHED',
  'WORK_ORDER_GET_TECH_ROUTE_FAILED',

  'GET_TECH_STATUS_STARTED',
  'GET_TECH_STATUS_FINISHED',
  'GET_TECH_STATUS_FAILED',

  'SET_TECH_STATUS_READY',
  'SET_TECH_STATUS_IN_ROUTE',
  'SET_TECH_STATUS_ON_BREAK',
  'SET_TECH_STATUS_OFF_BREAK',
  'SET_TECH_STATUS_UNDO_ON_JOB',
  'SET_TECH_STATUS_UNDO_IN_ROUTE',
  'SET_TECH_STATUS_NOT_READY',
  'SET_TECH_STATUS_ON_JOB',
  'SET_TECH_STATUS_FINISHED',
  'SET_TECH_STATUS_FAILED',

  'INVENTORY_TRANSFER_STARTED',
  'INVENTORY_TRANSFER_FINISHED',
  'INVENTORY_TRANSFER_FAILED',

  'WORK_ORDER_BY_ORDER_ID_GET_STARTED',
  'WORK_ORDER_BY_ORDER_ID_GET_FINISHED',
  'WORK_ORDER_BY_ORDER_ID_GET_FAILED',

  'OUTLET_UPDATE',
  'OUTLET_UPDATE_STARTED',
  'OUTLET_UPDATE_FINISHED',
  'OUTLET_UPDATE_FAILED',

  'ORDER_CLOSE_STARTED',
  'ORDER_CLOSE_WAITING',
  'ORDER_CLOSE_FINISHED',
  'ORDER_CLOSE_FAILED',
  'ORDER_CLOSE_REQUEST_ADD_STARTED',
  'ORDER_CLOSE_REQUEST_ADD_FINISHED',
  'ORDER_CLOSE_REQUEST_ADD_FAILED',


];



// WEBPACK FOOTER //
// ./src/constants/actionLoggingConfig.js